import { useEffect, useState } from "react";
import Url from '../LocalService';
import { useFetchServices } from "../hooks/useFetchServices";

export const Actions = () => {
    let [dto, setDto] = useState([]);
    let [lookup, setLookup] = useState([]);
    let [filterdto, setFilterdto] = useState(undefined);
    //Length is for showing the Data Loading message.
    let [dtoLength, setDtoLength] = useState(null);
    let fechtservices = useFetchServices();

    const loadDto = () =>{
      /*fetch(Url + "orcamento.getall.php")
      .then((res) => {
        return res.json();
      })*/
      fechtservices.executeService({method:"GET",endpoint:"orcamento.getall.php",body:{request:"getall"}})
      .then((data) => {
        if (data.success) {
            setDto(data.data.reverse());
            setDtoLength(true);
        } else {
            setDtoLength(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    };

    useEffect(() => {
      loadDto();
      }, []);

    
    useEffect(() => {
        /*fetch(Url + "tarefa.lookup.php")
          .then((res) => {
            return res.json();
          })*/
          fechtservices.executeService({method:"GET",endpoint:"tarefa.lookup.php",body:{request:"lookup"}})
          .then((data) => {
            if (data.success) {
              setLookup(data.data);
            } 
          })
          .catch((err) => {
            console.log(err);
          });
      }, [fechtservices]);

    const getItemlookup = (theID) => {
      let found = lookup.filter((dt) => {
        return dt.idtarefa === theID;
      });
      let nome = "";
      found.map((fnd) =>{
        nome = fnd.nome;
      });
      return nome;
    };

    const testDto = (tested) => {
      if (tested.aceito === undefined)
        tested ={
          ...tested,
          aceito: false,
        };
      return tested;
    };

    const insertDto = (newDto) => {
        //newDto = {...testDto(newDto),};
        //console.log(JSON.stringify(newDto));
        /*
        fetch(Url + "orcamento.insert.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newDto),
        })
        .then((res) => {
            return res.json();
        })
        */
        fechtservices.executeService({method:"POST",endpoint:"orcamento.insert.php",body:newDto})
        .then((data) => {
            if (data) {
                setDto([
                {
                    idorcamento: data.idorcamento,
                    ...newDto,
                },
                    ...dto,
                ]);
                setDtoLength(true);
                loadDto();
            } else {
                alert(data.msg);
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };
    
  // Enabling the edit mode for a listed.
  const editMode = (idorcamento) => {
      dto = dto.map((dt) => {
      if (dt.idorcamento === idorcamento) {
        dt.isEditing = true;
        return dt;
      }
      dt.isEditing = false;
      return dt;
    });
    setDto(dto);
  };

  // Cance the edit mode.
  const cancelEdit = (idorcamento) => {
    dto = dto.map((dt) => {
      if (dt.idorcamento === idorcamento) {
        dt.isEditing = false;
        return dt;
      }
      return dt;
    });
    setDto(dto);
  };

  // Updating a dto.
  const updateDto = (dtoData) => {
    dtoData = {...testDto(dtoData),}; 
    /*fetch(Url + "orcamento.update.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dtoData),
    })
      .then((res) => {
        return res.json();
      })*/
      fechtservices.executeService({method:"POST",endpoint:"orcamento.update.php",body:dtoData})
      .then((data) => {
        if (data.success) {
          dto = dto.map((dt) => {
            if (dt.idorcamento === dtoData.idorcamento) {
              dt.isEditing = false;
              dt.fornecedor = dtoData.fornecedor;
              dt.contato = dtoData.contato;
              dt.quantidade = dtoData.quantidade;
              dt.precounitario = dtoData.precounitario;
              dt.total = dtoData.total;
              dt.aceito = dtoData.aceito;
              dt.idtarefa = dtoData.idtarefa;
              dt.tarefa = getItemlookup(dtoData.idtarefa);
              return dt;
            } else if (dtoData.aceito === "1" && dt.idtarefa === dtoData.idtarefa) {
              dt.aceito = "0";              
              return dt;
            }
            return dt;
          });
          setDto(dto);
        } else {
          alert("Não foi possível atualizar os dados");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

    // Deleting.
    const deleteDto = (theID) => {
      // filter outing the.
    let dtoDeleted = dto.filter((dt) => {
      return dt.idorcamento !== theID;
    });
    /*
    fetch(Url + "orcamento.delete.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idorcamento: theID }),
    })
      .then((res) => {
        return res.json();
      })
      */
      fechtservices.executeService({method:"POST",endpoint:"orcamento.delete.php",body:{ idorcamento: theID }})
      .then((data) => {
        if (data.success) {
          setDto(dtoDeleted);
          if (dto.length === 1) {
            setDtoLength(0);
          }
        } else {
          alert(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return {
    dto,
    editMode,
    cancelEdit,
    updateDto,
    insertDto,
    deleteDto,
    dtoLength,
    lookup,
    getItemlookup,
    filterdto,
    setFilterdto,
   };

}